import { I18n } from '@calendly/i18n';
import { FilterMenuButton } from '@calendly/ui/components/filter-menu';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FilterMenuTriggerIcon, SchedulingFilterMenu, ensureFilterMenuPortalRoots } from 'components/cui_filter_menu';
import { useSettingsModalQueryParams } from 'components/use_settings_modal_query_params';
import { FILTER_PARAMS_HOSTS, FILTER_PARAMS_OWNERS, FILTER_PARAMS_PERMISSION, FILTER_PARAMS_USERS } from './constants';
import { DropdownContent } from './dropdown_content';
import { pushGetParams } from '../../actions/core/navigation';
const containerCss = "c1hna1rs";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const filterByCss = "f5333w5";
const FilterBy = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filterByCss, props.className)} />;
});
const triggerLabelGapCss = "t125qopv";
const TriggerLabel = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(triggerLabelGapCss, props.className)} />);
const getButtonText = appliedFilters => <FilterBy>
    <BodyText inline as="div">{I18n.t('publisher.event_types.filters.button')}</BodyText>
    {appliedFilters > 0 && <BodyText inline as="div">
      (
      {appliedFilters}
      )
    </BodyText>}
  </FilterBy>;
const getNumericFilters = (params, key) => params[key]?.map(Number) || [];
const buildFilterParamUpdates = ({
  selectedHostIds,
  selectedOwnerIds,
  selectedUserIds,
  selectedPermission
}) => ({
  [FILTER_PARAMS_HOSTS]: selectedHostIds?.length ? selectedHostIds : null,
  [FILTER_PARAMS_OWNERS]: selectedOwnerIds?.length ? selectedOwnerIds : null,
  [FILTER_PARAMS_USERS]: selectedUserIds?.length ? selectedUserIds : null,
  [FILTER_PARAMS_PERMISSION]: selectedPermission || null
});
const clearFilterParamUpdates = () => ({
  [FILTER_PARAMS_HOSTS]: null,
  [FILTER_PARAMS_OWNERS]: null,
  [FILTER_PARAMS_USERS]: null,
  [FILTER_PARAMS_PERMISSION]: null
});
export const FiltersButton = ({
  scopeOverride
}) => {
  const params = useSettingsModalQueryParams();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const hostIds = getNumericFilters(params, FILTER_PARAMS_HOSTS);
  const ownerIds = getNumericFilters(params, FILTER_PARAMS_OWNERS);
  const userIds = getNumericFilters(params, FILTER_PARAMS_USERS);
  const permission = params[FILTER_PARAMS_PERMISSION] || '';
  const appliedFilters = [hostIds, ownerIds, userIds].filter(items => items.length > 0).length + (permission ? 1 : 0);
  const onClear = () => {
    dispatch(pushGetParams(clearFilterParamUpdates()));
  };
  const handleOpenChange = useCallback(nextIsOpen => {
    if (nextIsOpen) {
      ensureFilterMenuPortalRoots();
    }
    setIsOpen(nextIsOpen);
  }, []);
  const onCancel = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onSearch = useCallback(({
    selectedHostIds,
    selectedOwnerIds,
    selectedUserIds,
    selectedPermission
  }) => {
    dispatch(pushGetParams(buildFilterParamUpdates({
      selectedHostIds,
      selectedOwnerIds,
      selectedUserIds,
      selectedPermission
    })));
    setIsOpen(false);
  }, [dispatch]);
  return <Container>
      <SchedulingFilterMenu isOpen={isOpen} onOpenChange={handleOpenChange} onClose={onCancel} contentMinWidth="comfortable" responsive={false} placement="bottom start">
        <FilterMenuButton hasSelection={appliedFilters > 0} data-calendly-label="filter-button" aria-label={I18n.t('publisher.event_types.filters.button')} disableArrow>
          <TriggerLabel>
            <FilterMenuTriggerIcon selected={appliedFilters > 0} />
            {getButtonText(appliedFilters)}
          </TriggerLabel>
        </FilterMenuButton>
        {isOpen && <DropdownContent contentTestId="scheduling-filter-menu-content" aria-label={I18n.t('publisher.event_types.filters.button')} initialHostIds={hostIds} initialOwnerIds={ownerIds} initialUserIds={userIds} initialPermission={permission} onSearch={onSearch} onCancel={onCancel} scopeOverride={scopeOverride} />}
      </SchedulingFilterMenu>
      {appliedFilters > 0 && <div>
          <MinimalButton onClick={onClear}>
            {I18n.t('publisher.event_types.filters.clear')}
          </MinimalButton>
        </div>}
    </Container>;
};

require("./filters_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filters_button.js");